const mappedCountries = require('../../../../../../config/mapCountriesConfig.json');
const cookieUtils = require('../../../common/utils/cookieUtils');
const countriesUtils = require('../../../common/utils/countriesUtils');

function checkSelectOption(select, option) {
  // eslint-disable-next-line no-param-reassign
  select.selectedIndex = (option && option.index) ? option.index : 0;
  $(select).trigger('change');
}

function setPrefixSelectorData(select, countryCode) {
  const option = select.querySelector(
    `option[data-country-code='${countryCode}']`,
  );
  checkSelectOption(select, option);
}

function setPrefixSelectorDataFromValue(select, value) {
  const option = select.querySelector(`option[value='${value}']`);
  checkSelectOption(select, option);
}

/** maps country values to temporal ones getted from JSON conf. file */
function mapCountry(country) {
  return mappedCountries[country]?.countryCode || country;
}

/**
 * Sets the select country option from the Geolocation-Country endpoint
 * @param  {Element} select - Country prefix select in which geolocation country will be selected
 */
function setCountryFromGeolocation(select) {
  const url = $(select).data('country-url');
  $.ajax({
    url,
    method: 'GET',
    dataType: 'json',
    success(data) {
      const country = data.countryCode
        ? data.countryCode
        : '';
      setPrefixSelectorData(select, country);
    },
    error() {
      setPrefixSelectorData(select, '');
    },
  });
}

module.exports = {
  init() {
    const self = this;
    // cache phones object
    const { FRONT_CONFIG } = window;
    this.phones = FRONT_CONFIG.phoneValidation?.regexByCountryCode;
    // initialise all options
    $('.country-prefix-selector__select').each(function eachCountrySelectorSelect() {
      self.initCountryPrefix(this);
      // get selected option country code and use it to get the value in phone regex json
      self.updatePhoneRegex(this, self.getSelectedOptionCountry(this));
    });
  },
  getSelectedOptionCountry(select) {
    return select.options[select.selectedIndex].getAttribute('data-country-code');
  },
  updatePhoneRegex(select, country) {
    const $parent = $(select).closest('.phone-fields');
    const $phone = $parent.find('.phone-fields__phone-number input');
    // Return the regex defined for that country in the json
    // Or return a default regex in case it is not found
    const regexString = this.phones[country] || this.phones.default;

    $phone.attr('pattern', regexString);
  },
  initCountryPrefix(select) {
    const { initiallySelected } = select.dataset;

    if ($(select).attr('data-init')) {
      return;
    }

    this.changeEvent(select);

    if (initiallySelected && initiallySelected !== '') {
      setPrefixSelectorDataFromValue(select, initiallySelected);
    } else {
      let bylHeader = document.querySelector('#byl-header');
      if (bylHeader === null) {
        bylHeader = document.querySelector('.header-no-menu');
      }
      const { locale } = bylHeader !== null ? bylHeader.dataset : {};

      if (locale) {
        const country = mapCountry(locale.substring(locale.length - 2).toUpperCase());

        if (countriesUtils.doesLocaleCountryBelongToMulticountrySite(country)) {
          const dispatcherCookieData = cookieUtils.getDataFromDispatcherCookie();
          if (dispatcherCookieData.country) {
            setPrefixSelectorData(select, dispatcherCookieData.country);
          } else {
            setCountryFromGeolocation(select);
          }
        } else {
          setPrefixSelectorData(select, country);
        }
      } else {
        checkSelectOption(select, false);
      }
    }

    $(select).attr('data-init', 'true');
  },
  changeEvent(select) {
    const self = this;
    $(select).on('change', function onSelectChange() {
      const option = this.options[this.selectedIndex];

      option.setAttribute('data-text', option.text);
      option.text = option.value;

      // Reset texts for all other but current
      for (let i = this.options.length - 1; i >= 0; i--) {
        // eslint-disable-next-line no-continue
        if (i === this.selectedIndex) continue;
        const text = this.options[i].getAttribute('data-text');
        if (text) this.options[i].text = text;
      }

      // update sibling phone field pattern
      self.updatePhoneRegex(select, self.getSelectedOptionCountry(select));
    });
  },
};
